module.exports = __webpack_public_path__ + "img/fbt-iocn03.b4b1814c.svg";